'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTrash = function TiTrash(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 11.7h-1.7v-1.7c0-1.8-1.5-3.3-3.3-3.3h-11.7c-1.8 0-3.3 1.5-3.3 3.3v1.7h-1.7c-0.9 0-1.6 0.7-1.6 1.6s0.7 1.7 1.6 1.7v13.3c0 3.7 3 6.7 6.7 6.7h8.3c3.7 0 6.7-3 6.7-6.7v-13.3c0.9 0 1.7-0.7 1.7-1.7s-0.8-1.6-1.7-1.6z m-16.7-1.7h11.7v1.7h-11.7v-1.7z m13.4 18.3c0 1.9-1.5 3.4-3.4 3.4h-8.3c-1.8 0-3.3-1.5-3.3-3.4v-13.3h15v13.3z m-12.5-10.8c-0.5 0-0.9 0.4-0.9 0.8v10c0 0.5 0.4 0.9 0.9 0.9s0.8-0.4 0.8-0.9v-10c0-0.4-0.4-0.8-0.8-0.8z m3.3 0c-0.5 0-0.8 0.4-0.8 0.8v10c0 0.5 0.3 0.9 0.8 0.9s0.8-0.4 0.8-0.9v-10c0-0.4-0.3-0.8-0.8-0.8z m3.3 0c-0.4 0-0.8 0.4-0.8 0.8v10c0 0.5 0.4 0.9 0.8 0.9s0.9-0.4 0.9-0.9v-10c0-0.4-0.4-0.8-0.9-0.8z m3.4 0c-0.5 0-0.9 0.4-0.9 0.8v10c0 0.5 0.4 0.9 0.9 0.9s0.8-0.4 0.8-0.9v-10c0-0.4-0.4-0.8-0.8-0.8z' })
        )
    );
};

exports.default = TiTrash;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/trash.js
// module id = 2234
// module chunks = 0